import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  /* border-radius: 12px;
  border: 1px solid red; */
  /* margin-bottom: 24px; */
  .companies {
    .css-x1skeu-MuiInputBase-root-MuiInput-root:before {
      /* border: 1px solid red; */
      /* display: none; */
    }
  }
  .css-1q60rmi-MuiAutocomplete-endAdornment {
    display: flex;
    .MuiIconButton-root {
      width: 16px;
      height: 16px;
    }
    .MuiSvgIcon-root {
      width: 16px;
      height: 16px;
    }
  }
  div.MuiAutocomplete-inputRoot {
    height: 40px;
    div:not(:first-child):not(.MuiAutocomplete-endAdornment) {
      display: none;
    }
  }
  div.MuiAutocomplete-tag {
    height: 22px;
    font-size: 12px;
    text-align: right;
  }
  span.MuiAutocomplete-tag {
    display: block;
  }
  form {
    /* border: 1px solid red; */
    padding: 32px 32px 0;
    display: block;
    box-shadow: 0 0 5px 0 rgba(181, 181, 181, 0.26);
    border-radius: 12px;
    background: #ffffff;
  }
  .search-wrapper {
    display: flex;
  }
  .left {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 300ms linear;
    .line {
      display: flex;
      width: 100%;
      transition: all 300ms linear;
      /* border: 1px solid red; */
      gap: 48px;
      > div {
        flex: 1;
      }
    }
  }

  .button-group {
    height: 100%;
    margin-left: 64px;
    display: flex;
    /* flex-direction: column; */
    /* justify-content: space-between;
    align-items: center; */
    .reset {
      /* margin-bottom: 24px; */
      margin-right: 24px;
    }
    .search {
      margin-right: 0;
    }
  }
  .first-line {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    gap: 48px;
    .css-jjpacl-MuiFormControl-root {
      min-width: 300px;
    }
    > div {
      /* width: 25%; */
      flex: 1;
      /* margin-right: 48px; */
    }
  }

  .toggle {
    /* margin-top: ${(props) => (props.collapse ? '' : '24px')}; */
    text-align: center;
    .icon {
      cursor: pointer;
      width: 28px;
      height: 14px;
    }
  }
`;
export default SearchGroupStyled;
